(() => {
    // ========= STATE =========
    let consent = {
        marketing: false,
        analytics: false
    }

    // ========= CONSENT SYNC =========
    function setShopifyConsent(marketing, analytics) {
        try {
            const opts = {
                headlessStorefront: true,
                storefrontRootDomain: CONFIG.storefrontRootDomain,
                checkoutRootDomain: CONFIG.checkoutRootDomain,
                storefrontAccessToken: CONFIG.storefrontAccessToken
            }
            window.Shopify?.customerPrivacy?.setTrackingConsent?.({
                marketing: !!marketing,
                analytics: !!analytics,
                preferences: !!analytics, // adjust if you split prefs separately
                sale_of_data: false
            }, opts)
        } catch (e) { }
    }

    function evaluateConsent() {
        const m = !!(window.Cookiebot && Cookiebot.consent && Cookiebot.consent.marketing)
        const a = !!(window.Cookiebot && Cookiebot.consent && Cookiebot.consent.statistics) // Cookiebot "statistics" → analytics
        consent.marketing = m
        consent.analytics = a

        // Sync to Shopify
        setShopifyConsent(m, a)
    }

    window.addEventListener('CookiebotOnAccept', evaluateConsent)
    window.addEventListener('CookiebotOnDecline', evaluateConsent)
    document.addEventListener('DOMContentLoaded', evaluateConsent)

    var shown = false
    function reveal() { if (shown) return; shown = true; document.documentElement.classList.add('cookiebot-show') }

    // Show after 4s to let the hero load, or on first interaction
    var t = setTimeout(reveal, 4000);
    ['scroll', 'click', 'keydown', 'touchstart'].forEach(function (evt) {
        window.addEventListener(evt, function once() { reveal(); clearTimeout(t) }, { once: true, passive: true })
    })
})()
